/**
 * @generated SignedSource<<605114997be2b057d5f0bf80c0b53f5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type PeopleDirectoryViewQuery$variables = {
  cloudId: string;
  organisationId: string;
  skipOldCheck: boolean;
};
export type PeopleDirectoryViewQuery$data = {
  readonly hasUsers?: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "CpusSearchUserEdge";
    } | null> | null;
  } | null;
};
export type PeopleDirectoryViewQuery = {
  response: PeopleDirectoryViewQuery$data;
  variables: PeopleDirectoryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipOldCheck"
},
v3 = [
  {
    "condition": "skipOldCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "hasUsers",
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "kind": "Variable",
            "name": "organisationId",
            "variableName": "organisationId"
          },
          {
            "kind": "Literal",
            "name": "q",
            "value": "*"
          }
        ],
        "concreteType": "CpusSearchUserConnection",
        "kind": "LinkedField",
        "name": "peopleTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CpusSearchUserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PeopleDirectoryViewQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PeopleDirectoryViewQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d25f98174aa136c252f1e565a52a7aeb",
    "id": null,
    "metadata": {},
    "name": "PeopleDirectoryViewQuery",
    "operationKind": "query",
    "text": "query PeopleDirectoryViewQuery(\n  $organisationId: String!\n  $cloudId: String!\n  $skipOldCheck: Boolean!\n) {\n  hasUsers: peopleTql(organisationId: $organisationId, cloudId: $cloudId, q: \"*\", first: 1) @skip(if: $skipOldCheck) {\n    edges {\n      __typename\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "40f232390bcfaeb00ef55c8525af6116";

export default node;
